export default __webpack_public_path__ + "static/media/YorkIE_Fuel-mint.4558618f.svg";